// extracted by mini-css-extract-plugin
export default {"card":"tZ-z","carouselContainer":"uZ-z","carouselContent":"vZ-z"};